/* eslint-disable react/no-unescaped-entities */
import { css } from '@emotion/react'
import { memo } from 'react'
import { getThemeSpacing } from '../../../styles/appTheme'
import { palette } from '../../../styles/colors'

const rootStyles = css({
    background: palette.drawerBackground,
    color: palette.mfcWarning,
    padding: getThemeSpacing(3),
    paddingTop: getThemeSpacing(4),
    width: '100%',
})

const messageStyles = css({
    fontStyle: 'italic',
    fontSize: 16,
    lineHeight: 1.66,
    letterSpacing: '0.0333em',
    fontWeight: 400,
    textAlign: 'center',
    wordBreak: 'normal' as const,
})

const Error = ({ message = 'Something went wrong!' }) => (
    <div css={rootStyles} data-testid="ErrorModal__Container">
        <h6 className="typography centered">Oops, we've got an error!</h6>
        <div css={messageStyles}>{message}</div>
    </div>
)

export default memo(Error)
